module.exports = __webpack_public_path__ + "assets/5e3bd412309506f14a83fbdb2bba8eec.mp3";